import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import CancelAppointmentPage from './CancelAppointmentPage.js';

export default WithGASetup(CancelAppointmentPage, AuthContext);
